import {Link} from "react-router-dom";
import Icon from "../../components/selfcare/Icon.tsx";
import {imageMap} from "../../images/imageMap.ts";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import {pressReleases} from "./releases.ts";
import useRouteDatalayer from "../../components/useRouteDatalayer.tsx";
import Routing from "../../Routing.ts";
import IconArrow from "../../components/icons/IconArrow.tsx";
import IconDownload from "../../components/icons/IconDownload.tsx";

export default function PressPage() {
    setTitleAndMetaDescription("Presse - Hiper", "Her kan du downloade vores seneste pressemeddelelser og logo. Er du journalist og har spørgsmål, så kontakt vores presseansvarlige.")
    useRouteDatalayer("presse")

    return (
        <div className={"page-press"}>
            <section>
                <div className="content content--wide">
                    <div className="blurb">
                        <h1 className="heading heading--big">Presse</h1>
                        <p>
                            <Link to={Routing.About.Index} className="icon-link icon-link-left icon-link-rotate-180 back-link-widget">
                                <Icon component={IconArrow}/> <span className="text">Tilbage</span>
                            </Link>
                        </p>
                    </div>
                    <div className="blurb">
                        <h2 className="heading heading--small">Hent billeder og pressemeddelelser</h2>
                        <p>
                            Her kan du downloade vores seneste pressemeddelelser samt billeder i høj opløsning,
                            som du kan bruge, hvis du er journalist.
                        </p>
                        <p>
                            Er du journalist og har spørgsmål til os, så send en mail til vores presseansvarlige,
                            Mikkel Riis-Jørgensen på <a href="mailto:mikri@nuuday.dk">mikri@nuuday.dk</a> eller ring&nbsp;på&nbsp;
                            <span className="nowrap"><a
                                href="tel:+4520771281"
                            >20 77 12 81</a>.</span>
                        </p>
                    </div>

                    <div className="grid">
                        {Object.entries(pressReleases).map(([key, release]) => {
                            return (
                                <div key={key} className="item">
                                    <div className="wrap-thing">
                                        <img src={release.img_list} alt={release.img_alt}/>
                                        <div className="wrap-thing-bar">
                                            <Link to={`${Routing.About.Press}/${release.slug}`}>
                                                Læs
                                                <Icon component={IconArrow}/>
                                            </Link>
                                        </div>
                                    </div>
                                    <h3 className="heading heading--montserrat">
                                        {release.heading}
                                        <span className="heading__title">
                                            Pressemeddelelse {release.date_human}
                                        </span>
                                    </h3>
                                </div>
                            )
                        })}

                        <div className="item">
                            <div className="wrap-thing">
                                <img src={imageMap.pr.hiper_preview} alt="Hiper logo uden payoff"/>
                                <div className="wrap-thing-bar wrap-thing-bar--border-top">
                                    <a href={imageMap.pr.hiper_positiv} target="_blank">
                                        Positiv
                                        <Icon component={IconDownload}/>
                                    </a>
                                    <a href={imageMap.pr.hiper_positiv} target="_blank">
                                        Negativ
                                        <Icon component={IconDownload}/>
                                    </a>
                                </div>
                            </div>
                            <h3 className="heading heading--montserrat">Logo uden payoff</h3>
                        </div>

                        <div className="item">
                            <div className="wrap-thing">
                                <img src={imageMap.pr.hiper_payoff_preview} alt="Hiper logo med payoff - vi er kun gode til internet"/>
                                <div className="wrap-thing-bar wrap-thing-bar--border-top">
                                    <a href={imageMap.pr.hiper_payoff_positiv} target="_blank">
                                        Positiv
                                        <Icon component={IconDownload}/>
                                    </a>
                                    <a href={imageMap.pr.hiper_payoff_negativ} target="_blank">
                                        Negativ
                                        <Icon component={IconDownload}/>
                                    </a>
                                </div>
                            </div>
                            <h3 className="heading heading--montserrat">Logo med payoff</h3>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
